(function (module) {
    "use strict";

    module.service('skuMktShrService', ['synchronousEventsBus', '$q', SkuMktShrService]);

    function SkuMktShrService(this: $TSFixMe, synchronousEventsBus: $TSFixMe, $q: ng.IQService) {
        const service = this;
        service.onBrandChange = (e: $TSFixMe, args: $TSFixMe) => {
            const brand = args.brand,
                marketForecast = args.forecast;
            brand.forecast = brand.forecast || {};
            brand.forecast.mkshr = new Array(marketForecast.pmForecast.length);

            var inputForecast = args.parameters.forecastType.typeId == 'value' ? brand.forecast.value : brand.forecast.volume;

            if (inputForecast && inputForecast.pmForecast) {
                service.calculateMktShr(brand.forecast.mkshr, inputForecast.pmForecast, marketForecast.pmForecast);
            }
            var promises = [];
            for (var sku of brand.skus) {
                promises.push(service.calculateSkuShrInBrand(args.brand, sku, args.parameters));
            }

            promises.push(synchronousEventsBus.$broadcast('sku.BrandMktShrCalculated', args));
            return $q.all(promises);
        };

        service.onSkuVolumeChange = (e: $TSFixMe, args: $TSFixMe) => {
            const sku = args.sku,
                marketForecast = args.forecast;

            if (sku.forecast && sku.forecast.pmForecast) {
                sku.forecast.mkshr = new Array(marketForecast.pmForecast.length);
                service.calculateMktShr(sku.forecast.mkshr, sku.forecast.pmForecast, marketForecast.pmForecast);
            }

            return synchronousEventsBus.$broadcast('sku.SkuMktShrCalculated', args);
        };


        service.calculateMktShr = (mktShrOuputArray: $TSFixMe, inputForecastArray: $TSFixMe, marketForecast: $TSFixMe) => {
            for (let index = marketForecast.length; index--;) {
                mktShrOuputArray[index] = marketForecast[index] == 0 ? 0 : inputForecastArray[index] / marketForecast[index] * 100;
            }
        }

        service.calculateSkuShrInBrand = (brand: $TSFixMe, sku: $TSFixMe, parameters: $TSFixMe) => {
            const isVolumeForecast = parameters.forecastType.typeId == 'volume';
            if (!sku.forecast.pmForecast)
                return;
            sku.forecast.brandShr = [];
            var brandData = (isVolumeForecast ? brand.forecast.volume : brand.forecast.value).pmForecast;
            for (let index = brandData.length; index--;) {
                sku.forecast.brandShr[index] = sku.forecast.pmForecast[index] / brandData[index];
            }
            return synchronousEventsBus.$broadcast('sku.SkuShrInBrandCalculated', { brand, sku });
        }


        service.registerEvents = () => {
            synchronousEventsBus.$on('sku.BrandVolumeCalculated', service.onBrandChange);
            synchronousEventsBus.$on('sku.BrandValueCalculated', service.onBrandChange);
            synchronousEventsBus.$on('sku.SkuVolumeCalculated', service.onSkuVolumeChange);
        }
    }

    module.run(['skuMktShrService', (service: $TSFixMe) => { service.registerEvents(); }]);

})(angular.module('topline.services'));
